import AOS from "aos";
import "aos/dist/aos.css";
import { useEffect, useState } from "react";
import "./contact.css";

export default function Contact() {
  const [user, setUser] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const { name, email, subject, message } = user;

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setUser({ ...user, [name]: value });
  };

  const sendValue = (e) => {
    e.preventDefault();
    console.log(user);
    window.alert("Something went wrong. Please Try again!");
    setUser({ name: "", email: "", subject: "", message: "" });
  };

  return (
    <div className="contact" id="contact">
      <div className="container">
        <div className="contactTitle" data-aos="fade-down">
          <h2 className="titleHead">Contact me</h2>
          <p className="titleDoc">get in touch</p>
        </div>

        <div className="contactDes">
          <div className="contactInfo" data-aos="fade-down">
            <div className="infoTitle">Get in Touch</div>
            <div className="address">
              <p>
                <strong>Phone:</strong>{" "}
                <a href="tel:+8801821647770" className="contactLink">
                  +880 182 1647 770
                </a>
              </p>
              <p>
                <strong>Email:</strong>{" "}
                <a href="mailto:rma0011239@gmail.com" className="contactLink">
                  rma0011239@gmail.com
                </a>
              </p>
            </div>
          </div>

          <div className="contactForm" data-aos="fade-up">
            <div className="formTitle">Message</div>
            <form onSubmit={sendValue}>
              <div className="formInputUp">
                <input
                  className="formText"
                  name="name"
                  value={name}
                  type="text"
                  placeholder="Name"
                  onChange={handleChange}
                  required
                />
                <input
                  className="formText"
                  name="email"
                  value={email}
                  type="email"
                  placeholder="Email"
                  onChange={handleChange}
                  required
                />
              </div>
              <input
                className="formText"
                name="subject"
                value={subject}
                type="text"
                placeholder="Subject"
                onChange={handleChange}
                required
              />
              <textarea
                className="formText"
                name="message"
                value={message}
                placeholder="Message..."
                onChange={handleChange}
                required
              />
              <input className="button" type="submit" value="Send Message" />
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
